<template>
  <v-card
      class="rounded-lg white" height="370"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text" style="font-size: medium">
      حساب های  <span class=" info--text mr-2 ml-2">خلاف ماهیت</span>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            ردیف
          </th>
          <th class="text-center">
            نام حساب
          </th>
          <th class="text-center">
            کد حساب
          </th>
          <th class="text-center">
            مانده بدهکار
          </th>
          <th class="text-center">
            مانده بستانکار
          </th>
          <th class="text-center">
            مشاهده گردش حساب
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(account, index) in accounts">
          <td class="text-center">{{index + 1}}</td>
          <td class="text-center">{{account.name}}</td>
          <td class="text-center">{{account.code}}</td>
          <td class="text-center">{{account.bed_remain}}</td>
          <td class="text-center">{{account.bes_remain}}</td>
          <td class="text-center">
            <open-ledger-btn :query="getSubAccountLedgerQuery(account)"/>
          </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

  </v-card>
</template>

<script>
import OpenLedgerBtn from "@/components/btns/OpenLedgerBtn";
export default {
  name: "AccountsWithDifferences",
  components: {
    OpenLedgerBtn
  },
  props: {
    id: {},
  },
  data() {
    return {
      accounts: null,
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(){
      this.request({
        url: this.endpoint('reports/balance?cols_count=2&level=3&show_differences=true'),
        method: "get",
        success: data => {
          this.accounts = data.splice(0,10)
        },
      })
    },
    getSubAccountLedgerQuery(item) {
      return {
        "ledger.account": item.id,
        "ledger.level": `level${item.level}`,
      };
    },

    to(item) {
      return {
        name: "SanadForm",
        params: {
          id: item.id,
        },
      };
    },

  },



}
</script>

<style scoped lang="scss"></style>

